import { render, staticRenderFns } from "./addTaskStoryModal.vue?vue&type=template&id=ff9ed2e4&scoped=true"
import script from "./addTaskStoryModal.vue?vue&type=script&lang=js"
export * from "./addTaskStoryModal.vue?vue&type=script&lang=js"
import style0 from "./addTaskStoryModal.vue?vue&type=style&index=0&id=ff9ed2e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9ed2e4",
  null
  
)

export default component.exports